export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/components/feed/resources/mounted.js